import type { Stripe } from '@stripe/stripe-js';
import { loadStripe } from '@stripe/stripe-js';

import { getEnvironmentConfig } from '@/constants/config';
import { Logger } from '@/utils/logging';

let stripePromise: Promise<Stripe | null> | null = null;

/**
 * Shared Stripe.js loader for web. Never rejects: when the script is blocked
 * or the network drops it resolves null, which `<Elements>` and callers
 * treat as "Stripe unavailable", and the next call tries to load it again.
 * Components read it once per mount (`useState(getStripePromise)`): Elements
 * ignores a changed `stripe` prop, so a call per render only reloads the script.
 */
export const getStripePromise = (): Promise<Stripe | null> => {
  if (!stripePromise) {
    stripePromise = loadStripe(getEnvironmentConfig().stripePublicKey).catch(
      (error: unknown) => {
        Logger.warn('Stripe.js failed to load', {
          message: error instanceof Error ? error.message : String(error),
        });
        stripePromise = null;
        return null;
      },
    );
  }
  return stripePromise;
};
